import { PM_COMPONENTS_OPT, OUTFORZ_STATUS_OPT } from "../../../config/const";

const yesNo = row => (row.price_monitoring ? "✓" : "—");

export default {
  slug: "categories",
  endpoint: "categories_point/",
  titleKey: "categories_title",
  columns: [
    { field: "name", label: "f_name" },
    { label: "f_price_monitoring", format: yesNo },
  ],
  fields: [
    { name: "name", type: "text", label: "f_name", required: true },
    { name: "price_monitoring", type: "checkbox", label: "f_price_monitoring" },
    { name: "price_monitoring_components", type: "chips", label: "f_pm_components", options: PM_COMPONENTS_OPT },
    { name: "price_monitoring_required_components", type: "chips", label: "f_pm_required", options: PM_COMPONENTS_OPT },
    { name: "send_to_outforz", type: "checkbox", label: "f_send_outforz" },
    { name: "is_auto_approve_price_monitoring_reports", type: "checkbox", label: "f_auto_approve" },
    { name: "status_to_send_to_outforz", type: "select", label: "f_status_outforz", options: OUTFORZ_STATUS_OPT },
    { name: "default_tags", type: "entity", entity: "tags", isMulti: true, label: "f_default_tags", wide: true },
  ],
  injectOnCreate: (item, me) => ({ ...item, company: me && me.company ? me.company.id : null }),
};
